import { injectable } from 'inversify';

import { HttpService } from '@vk-hr-tek/core/http';
import { UnmarshallerService } from '@vk-hr-tek/core/unmarshaller';

import { AuthInstanceResponse } from '@app/gen/users';

@injectable()
export class AuthService {
  constructor(
    private http: HttpService,
    private unmarshaller: UnmarshallerService,
  ) {}

  async getAuthInstance() {
    return {
      auth_instances: (
        await this.unmarshaller.unmarshall(
          await this.http.get('/auth_instance', {}, { withAuth: false }),
          AuthInstanceResponse,
        )
      ).auth_instances,
    };
  }

  async getAuthSourceLogo() {
    const result = this.http.getFile('/auth_source/logo', { withAuth: false });

    return result;
  }
}
